import gsap from 'gsap'
import SplitText from 'gsap/dist/SplitText'
import { forEach } from 'lodash'

export type Motion = {
  timeline: GSAPTween | GSAPTimeline
  revert: () => void
}

export const getScrollTriggerOptions = (vars?: ScrollTrigger.StaticVars) => {
  return {
    start: 'top 90%',
    end: 'bottom top',
    toggleActions: 'play none none reverse',
    markers: false,
    once: true,
    ...vars
  }
}

export const createSplitTextLines = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, { type: 'lines', mask: 'lines' })
  forEach(splitText.lines, (line) => {
    if (line.innerHTML.length === 0) {
      line.innerHTML = '&nbsp;'
    }
  })
  return splitText
}

export const createCharsMotion = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, { type: 'lines,words,chars', mask: 'lines' })
  const timeline = gsap.from(splitText.chars, {
    yPercent: 110,
    duration: 0.8,
    ease: 'power3.out',
    stagger: {
      amount: 0.35
    }
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}

export const createWordsMotion = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, {
    type: 'lines,words',
    mask: 'lines',
    linesClass: 'line',
    wordsClass: 'word'
  })
  const timeline = gsap.from(splitText.words, {
    yPercent: 110,
    duration: 0.6,
    ease: 'power3.out',
    stagger: {
      amount: 0.15
    }
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}

export const createMaskMotion = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, { type: 'lines', mask: 'lines' })
  const timeline = gsap.from(splitText.lines, {
    opacity: 0,
    yPercent: 110,
    duration: 0.6,
    ease: 'power2.out'
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}

export const createLinesMotion = (target: gsap.DOMTarget) => {
  const splitText = createSplitTextLines(target)
  const timeline = gsap.from(splitText.lines, {
    opacity: 0,
    yPercent: 110,
    duration: 0.5,
    ease: 'power2.out',
    stagger: {
      amount: 0.15
    }
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}

export const createFadeMotion = (target: gsap.DOMTarget) => {
  const timeline = gsap.from(target, {
    opacity: 0,
    y: 30,
    duration: 0.5,
    ease: 'power2.out',
    stagger: {
      amount: 0.15
    }
  })

  const revert = () => {
    return
  }

  return {
    timeline,
    revert
  }
}

export const createImageMaskMotion = (image: gsap.DOMTarget, mask: gsap.DOMTarget) => {
  return gsap
    .timeline({ defaults: { duration: 1, ease: 'power3.out' } })
    .from(image, { scale: 1.6 }, 0)
    .from(mask, { scale: 0.8 }, 0)
}
